import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchLatestSermon } from '../../redux/slices/latestSermonSlice';
import { useNavigate, useLocation } from 'react-router-dom';
import Ministries from '../Ministries/Ministries';
import Services from '../Services/Services';
import SermonsSection from '../../components/reuseable/SermonsSection';
import DetailsModal from '../../components/reuseable/DetailsModal';
import { eventsCache } from '../../services/eventsCache';
import slide1 from '../../assets/images/Hero/slide1.jpg'
import slide2 from '../../assets/images/Hero/slide2.jpg'
import slide3 from '../../assets/images/Hero/slide3.jpg'
import slide4 from '../../assets/images/Hero/slide4.jpg'
import Jan25 from '../../assets/images/Hero/HeroSurmons&Events/25Jan.png'

import { isPastDate } from '../../utils/dateFormatter';
const Home = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [activeCard, setActiveCard] = useState('sermon');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [modalType, setModalType] = useState('sermon');
  const [eventOne, setEventOne] = useState(null);
  const [latestNews, setLatestNews] = useState(null);
  const [verseOfDay, setVerseOfDay] = useState(null);
  const [isPortraitVideo, setIsPortraitVideo] = useState(false);
  // Home intro video popup is temporarily disabled.
  // Keep this block for future campaigns/promotions when needed again.
  // const [showIntroVideo, setShowIntroVideo] = useState(false);
  // const [requiresAudioStart, setRequiresAudioStart] = useState(false);
  // const introVideoUrl = 'https://firebasestorage.googleapis.com/v0/b/img-container-lfnc.firebasestorage.app/o/EventVideos%2FWhatsApp%20Video%202026-06-21%20at%2011.39.07%20PM.mp4?alt=media&token=b4b11d70-7ad6-471a-b83d-29cd6808f0b0';
  // const introVideoRef = useRef(null);
  // const introVideoLandingUrl = 'https://www.lfnc.in/?introVideo=1';
  // const whatsappShareUrl = `https://wa.me/?text=${encodeURIComponent(`Watch this special video from LFNC: ${introVideoLandingUrl}\n\nPastor: Ps. Roshan Rai,\nLiving Faith Nepali Church Koramangala Bengaluru`)}`;

  const verses = [
    {
      english: "Cast all your anxiety on him because he cares for you.",
      nepali: "आफ्ना सबै चिन्ता उहाँमा सुम्पिदेऊ, किनकि उहाँले तिमीहरूको वास्ता गर्नुहुन्छ।",
      reference: "1 Peter 5:7",
      referenceNepali: "१ पत्रुस ५:७"
    },
    {
      english: "The joy of the LORD is your strength.",
      nepali: "परमप्रभुको आनन्द नै तिम्रो बल हो।",
      reference: "Nehemiah 8:10",
      referenceNepali: "नहेम्याह ८:१०"
    },
    {
      english: "Peace I leave with you; my peace I give you.",
      nepali: "म तिमीहरूलाई शान्ति छोडेर जान्छु; मेरो शान्ति तिमीहरूलाई दिन्छु।",
      reference: "John 14:27",
      referenceNepali: "यूहन्ना १४:२७"
    },
    {
      english: "Taste and see that the LORD is good; blessed is the one who takes refuge in him.",
      nepali: "चाखेर हेर कि परमप्रभु कति असल हुनुहुन्छ; उहाँमा शरण लिने धन्य हो।",
      reference: "Psalm 34:8",
      referenceNepali: "भजन ३४:८"
    },
    {
      english: "Your word is a lamp for my feet, a light on my path.",
      nepali: "तपाईंको वचन मेरा पाइलाहरूका लागि बत्ती र मेरो मार्गका लागि ज्योति हो।",
      reference: "Psalm 119:105",
      referenceNepali: "भजन ११९:१०५"
    },
    {
      english: "Come to me, all you who are weary and burdened, and I will give you rest.",
      nepali: "हे परिश्रम गर्ने र भारी बोझ बोक्नेहरू हो, म कहाँ आओ, म तिमीहरूलाई विश्राम दिनेछु।",
      reference: "Matthew 11:28",
      referenceNepali: "मत्ती ११:२८"
    },
    {
      english: "Delight yourself in the LORD, and he will give you the desires of your heart.",
      nepali: "परमप्रभुमा आनन्दित होऊ, अनि उहाँले तिम्रो हृदयका इच्छाहरू पूरा गर्नुहुनेछ।",
      reference: "Psalm 37:4",
      referenceNepali: "भजन ३७:४"
    },
    {
      english: "My grace is sufficient for you, for my power is made perfect in weakness.",
      nepali: "मेरो अनुग्रह तिम्रो लागि पर्याप्त छ, किनकि मेरो शक्ति दुर्बलतामा सिद्ध हुन्छ।",
      reference: "2 Corinthians 12:9",
      referenceNepali: "२ कोरिन्थी १२:९"
    },
    {
      english: "If God is for us, who can be against us?",
      nepali: "यदि परमेश्वर हाम्रो पक्षमा हुनुहुन्छ भने, हाम्रो विरुद्धमा को हुन सक्छ?",
      reference: "Romans 8:31",
      referenceNepali: "रोमी ८:३१"
    },
    {
      english: "Let everything that has breath praise the LORD.",
      nepali: "जसमा श्वास छ, त्यस सबैले परमप्रभुको प्रशंसा गरोस्।",
      reference: "Psalm 150:6",
      referenceNepali: "भजन १५०:६"
    }
  ];

  const dispatch = useDispatch();


  // Get next Sunday date
  const getNextSunday = () => {
    const today = new Date();
    const dayOfWeek = today.getDay();
    const daysUntilSunday = dayOfWeek === 0 ? 0 : 7 - dayOfWeek;
    const nextSunday = new Date(today);
    nextSunday.setDate(today.getDate() + daysUntilSunday);
    return nextSunday.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };


  const { latestSermon, loading, error } = useSelector((state) => state.latestSermon);

  useEffect(() => {
    dispatch(fetchLatestSermon());
  }, [dispatch]);

  /**Uncomment when required for video */
  // useEffect(() => {
  //   const searchParams = new URLSearchParams(location.search);
  //   const forceFromSearch = searchParams.get('introVideo') === '1';
  //   const forceFromHash = typeof window !== 'undefined' && window.location.hash.includes('introVideo=1');
  //   const forceFromHref = typeof window !== 'undefined' && window.location.href.includes('introVideo=1');
  //   const forceIntroVideo = forceFromSearch || forceFromHash || forceFromHref;

  //   if (forceIntroVideo) {
  //     setShowIntroVideo(true);
  //     return;
  //   }

  //   setShowIntroVideo(true);
  // }, [location.search]);

  /**Uncomment when required for video */
  // useEffect(() => {
  //   if (!showIntroVideo || !introVideoRef.current) return;

  //   const tryPlayWithAudio = async () => {
  //     try {
  //       await introVideoRef.current.play();
  //       introVideoRef.current.volume = 1;
  //       await introVideoRef.current.play();
  //       setRequiresAudioStart(false);
  //     } catch (error) {
  //       setRequiresAudioStart(true);
  //     }
  //   };

  //   tryPlayWithAudio();
  // }, [showIntroVideo]);

  const nepaliWeekdays = [
    "आइतबार",
    "सोमबार",
    "मंगलबार",
    "बुधबार",
    "बिहीबार",
    "शुक्रबार",
    "शनिबार",
  ];

  const nepaliMonths = [
    "जनवरी",
    "फेब्रुअरी",
    "मार्च",
    "अप्रिल",
    "मे",
    "जुन",
    "जुलाई",
    "अगस्ट",
    "सेप्टेम्बर",
    "अक्टोबर",
    "नोभेम्बर",
    "डिसेम्बर",
  ];

  const nepaliDigits = ["०", "१", "२", "३", "४", "५", "६", "७", "८", "९"];

  const toNepaliNumber = (num) =>
    String(num).split("").map(d => nepaliDigits[d] ?? d).join("");

  const getNextSundayNepali = () => {
    const today = new Date();
    const dayOfWeek = today.getDay(); // 0 = Sunday
    const daysUntilSunday = dayOfWeek === 0 ? 0 : 7 - dayOfWeek;

    const nextSunday = new Date(today);
    nextSunday.setDate(today.getDate() + daysUntilSunday);

    // const weekday = nepaliWeekdays[nextSunday.getDay()];
    const day = toNepaliNumber(nextSunday.getDate());
    const month = nepaliMonths[nextSunday.getMonth()];
    const year = toNepaliNumber(nextSunday.getFullYear());

    // return `${weekday}, ${day} ${month} ${year}`;
    return `${day} ${month} ${year}`;
  };

  console.log('upcoming sermons', isPastDate(latestSermon?.date));

  const sermonData = {
    title: 'Sunday Service',
    description: `Sunday Worship Invitation | संगति निमन्त्रणा
Warm greetings from Living Faith New Church (LFNC) 🙏 लिभिङ्ग फेथ न्यु चर्च (LFNC) बाट न्यानो अभिवादन 🙏

We joyfully invite you and your family to join us for our Sunday Worship Service and be blessed by God’s Word and fellowship. हामी तपाईं र तपाईंको परिवारलाई हाम्रो आइतवारीय आराधना सेवामा सहभागी हुन र परमेश्वरको वचन र सङ्गतिद्वारा आशिषित हुन हार्दिक निमन्त्रणा गर्दछौं।

📅 Date | मिति: Sunday, ${getNextSunday()} | आइतबार, ${getNextSundayNepali()}

⏰ Time | समय: 07:30 AM onwards | बिहान ७:३० बजेदेखि

🎤 Guest Speaker | अतिथि वक्ता: Deacon Sunita Darnal | डिकन सुनिता दर्नाल

📍 Church Location | मण्डलीको स्थान:
5th Floor, Kay Arr Cornerstone, Maharaja Signal, 80 Feet Road, New Friends Colony, 4th Block, Koramangala, Bengaluru, Karnataka – 560034

👉 View Location on Google Maps | गुगल म्यापमा हेर्नुहोस्: https://www.google.com/maps/search/?api=1&query=Kay+Arr+Cornerstone+Koramangala+Bangalore

🌐 Visit our Website | हाम्रो वेबसाइट: https://www.lfnc.in

We look forward to worshipping together and experiencing God’s presence as one family in Christ. Please feel free to invite your friends and loved ones. हामी ख्रीष्टमा एकै परिवार भई सँगै आराधना गर्न र परमेश्वरको उपस्थितिको अनुभव गर्न चाहन्छौं। कृपया आफ्ना साथीभाइ र प्रियजनहरूलाई पनि निमन्त्रणा गर्नुहोला।

May God bless you abundantly. परमेश्वरले तपाईंलाई प्रशस्त आशिष दिउन्।

With love and prayers, प्रेम र प्रार्थना सहित,

Ps. Roshan Rai Living Faith New Church (LFNC) Bengaluru`,
    date: getNextSunday(),
    time: '07:30 AM - 09:00 AM',
    location: 'LFNC, Maharaja signal, 80 Feet Rd, New Friends Colony, 4th Block,Koramangala',
    speaker: 'Deacon Sunita Darnal',
    image: Jan25 ? Jan25 : slide1
  };

  const eventData = {
    title: 'New Year 2025 Celebration',
    description: 'Join us for a special New Year celebration service as we welcome 2025 together in worship, prayer, and thanksgiving. Let\'s reflect on God\'s faithfulness and step into the new year with hope and renewed faith.',
    date: 'Thursday, January 1, 2025',
    time: '07:30 AM - 09:30 AM',
    location: 'LFNC, Maharaja signal, 80 Feet Rd, New Friends Colony, 4th Block,Koramangala',
    image: slide3
  };

  const openModal = (type) => {
    setModalType(type);
    setModalData(type === 'sermon' ? latestSermon : eventOne ? eventOne : eventData);
    setIsModalOpen(true);
  };

  useEffect(() => {
    // const dayOfYear = Math.floor((new Date() - new Date(new Date().getFullYear(), 0, 0)) / 86400000);
    // setVerseOfDay(verses[dayOfYear % verses.length]);
    const dayOfYear = Math.floor(
      (new Date() - new Date(new Date().getFullYear(), 0, 0)) / 86400000
    );

    setVerseOfDay(verses[dayOfYear % verses.length]);
  }, []);

  // Prefetch events API on home page load
  useEffect(() => {
    eventsCache.prefetch();
    eventsCache.getEvents().then((data) => {
      const allEvents = Array.isArray(data?.[0]?.events) ? data[0].events : [];
      const nextUpcomingEvent = allEvents.find((event) => {
        if (!event?.date) return false;
        const parsedDate = new Date(event.date);
        if (Number.isNaN(parsedDate.getTime())) return false;
        return !isPastDate(event.date);
      });
      setEventOne(nextUpcomingEvent || null);

    }).catch((error) => {
      console.error("Error fetching events:", error);
      setEventOne(null);

    });

    // Fetch latest news
    import('../../api/apiClient').then(({ api }) => {
      api.get('/api/news-updates').then((response) => {
        const data = Array.isArray(response.data) ? response.data : (response.data?.data || []);
        if (data && data[0]) {
          setLatestNews(data[0]);
        }
      }).catch((error) => {
        console.error("Error fetching news:", error);
      });
    });
  }, []);

  const slides = [
    {
      id: 1,
      image: slide1,
      title: "Reaching to un-reached with the Love and Gospel of Jesus Christ",
      highlight: ["Love", "Gospel"]
    },
    {
      id: 2,
      image: slide2,
      title: "Join Our Community of Faith",
      highlight: ["Community", "Faith"]
    },
    {
      id: 3,
      image: slide3,
      title: "Growing Together in Spirit",
      highlight: ["Growing", "Spirit"]
    },
    {
      id: 4,
      image: slide4,
      title: "Serving with Purpose and Passion",
      highlight: ["Purpose", "Passion"]
    }
  ];

  // Auto slide every 3 seconds, pause on hover
  useEffect(() => {
    if (!isHovered) {
      const interval = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % slides.length);
      }, 3000);
      return () => clearInterval(interval);
    }
  }, [slides.length, isHovered]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const renderHighlightedText = (text, highlights) => {
    let result = text;
    highlights.forEach(highlight => {
      result = result.replace(
        highlight,
        `<span class="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 via-pink-400 to-red-400 animate-pulse font-bold drop-shadow-lg filter brightness-105 contrast-110" style="text-shadow: 0 0 10px rgba(168, 85, 247, 0.3), 0 0 20px rgba(236, 72, 153, 0.2), 0 0 30px rgba(239, 68, 68, 0.1);">${highlight}</span>`
      );
    });
    return { __html: result };
  };
  const videoRef = useRef(null);
  const hasUpcomingEvent = Boolean(eventOne);

  useEffect(() => {
    if (!hasUpcomingEvent && activeCard === 'event') {
      setActiveCard('sermon');
    }
  }, [hasUpcomingEvent, activeCard]);

  // Stop video on close
  // useEffect(() => {
  //   if (activeCard === 'event' && videoRef.current) {
  //     videoRef.current.pause();
  //     videoRef.current.currentTime = 0;
  //   }
  // }, [activeCard]);
  return (
    <div>
      {/* Intro Video Popup (temporarily disabled) */}
      {/* {showIntroVideo && (
        <div className="fixed inset-0 z-[100] bg-black/90 px-4 pt-20 pb-6 sm:pt-24 sm:pb-10">
          <div className="relative mx-auto h-full max-h-[85vh] w-full max-w-7xl rounded-3xl border border-white/20 bg-gradient-to-br from-black/75 via-purple-950/35 to-red-950/35 shadow-2xl">
            <div className="flex h-full flex-col p-3 sm:p-5">
              <div className="mb-3 flex items-center justify-between px-1">
                <p className="text-xs font-semibold uppercase tracking-[0.2em] text-purple-200">Featured Message</p>
                <div className="flex items-center gap-2">
                  <a
                    href={whatsappShareUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="rounded-lg bg-green-500/90 px-3 py-1.5 text-xs font-semibold text-white transition hover:bg-green-600"
                  >
                    Share on WhatsApp
                  </a>
                  <button
                    onClick={() => setShowIntroVideo(false)}
                    className="rounded-lg bg-white/10 px-3 py-1.5 text-xs font-semibold text-white transition hover:bg-white/20"
                  >
                    Skip
                  </button>
                  <button
                    onClick={() => setShowIntroVideo(false)}
                    className="rounded-full border border-white/30 bg-black/70 p-2 text-white transition duration-300 hover:scale-105 hover:bg-black"
                    aria-label="Close intro video"
                  >
                    <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>
              </div>

              <div className="relative flex flex-1 items-center justify-center overflow-hidden rounded-2xl border border-white/15 bg-black">
                <video
                  ref={introVideoRef}
                  controls
                  autoPlay
                  playsInline
                  preload="metadata"
                  download="false"
                  disablePictureInPicture
                  controlsList="nodownload"
                  onLoadedMetadata={(e) => {
                    const video = e.target;

                    setIsPortraitVideo(
                      video.videoHeight > video.videoWidth
                    );
                  }}
                  className={
                    isPortraitVideo
                      ? "max-h-full w-auto"
                      : "h-full w-full object-cover"
                  }
                >
                  <source src={introVideoUrl} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>

                {requiresAudioStart && (
                  <div className="absolute inset-0 flex items-center justify-center bg-black/55">
                    <button
                      onClick={async () => {
                        if (!introVideoRef.current) return;
                        introVideoRef.current.muted = false;
                        introVideoRef.current.volume = 1;
                        try {
                          await introVideoRef.current.play();
                          setRequiresAudioStart(false);
                        } catch (error) {
                          setRequiresAudioStart(true);
                        }
                      }}
                      className="rounded-xl bg-gradient-to-r from-red-500 to-purple-600 px-5 py-3 text-sm font-semibold text-white shadow-lg transition hover:scale-105 hover:from-red-600 hover:to-purple-700"
                    >
                      Tap to Play With Audio
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )} */}

      {/* Rewatch Intro Video (temporarily disabled) */}
      {/* {!showIntroVideo && (
        <button
          onClick={() => setShowIntroVideo(true)}
          className="fixed bottom-[max(5rem,calc(env(safe-area-inset-bottom)+4rem))] left-4 z-[90] rounded-full border border-white/20 bg-gradient-to-r from-red-500 to-purple-600 px-4 py-2 text-xs font-semibold text-white shadow-xl transition-all duration-300 hover:scale-105 hover:from-red-600 hover:to-purple-700 sm:bottom-5 sm:left-auto sm:right-4 sm:px-5 sm:py-2.5 sm:text-sm"
        >
          Watch Video
        </button>
      )} */}

      {/* Details Modal */}
      <DetailsModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        data={modalData}
        type={modalType}
      />

      {/* Hero Section */}
      <div className="relative w-full h-screen overflow-hidden">
        {/* Upcoming Card Switcher */}
        <div className="absolute top-2 md:top-4 right-4 z-50 w-80">
          {/* Tab Switcher */}
          <div className="flex gap-2 mb-3">
            <button
              onClick={() => setActiveCard('sermon')}
              className={`flex-1 py-2 px-4 rounded-xl font-semibold text-xs uppercase tracking-wide transition-all duration-300 ${activeCard === 'sermon'
                ? 'bg-gradient-to-r from-red-500 to-purple-600 text-white shadow-lg'
                : 'bg-white/10 backdrop-blur-md text-gray-300 hover:bg-white/20'
                }`}
            >
              Sermon
            </button>
            {hasUpcomingEvent && (
              <button
                onClick={() => setActiveCard('event')}
                className={`flex-1 py-2 px-4 rounded-xl font-semibold text-xs uppercase tracking-wide transition-all duration-300 ${activeCard === 'event'
                  ? 'bg-gradient-to-r from-red-500 to-orange-500 text-white shadow-lg'
                  : 'bg-white/10 backdrop-blur-md text-gray-300 hover:bg-white/20'
                  }`}
              >
                Event
              </button>
            )}
            <button
              onClick={() => setActiveCard('news')}
              className={`flex-1 py-2 px-4 rounded-xl font-semibold text-xs uppercase tracking-wide transition-all duration-300 ${activeCard === 'news'
                ? 'bg-gradient-to-r from-purple-500 to-pink-500 text-white shadow-lg'
                : 'bg-white/10 backdrop-blur-md text-gray-300 hover:bg-white/20'
                }`}
            >
              News
            </button>
          </div>

          {/* Sermon Card */}
          {activeCard === 'sermon' && (
            <div className="bg-gradient-to-br from-purple-500/20 to-blue-500/20 backdrop-blur-lg border border-white/20 rounded-2xl p-4 shadow-2xl">
              <div className="flex items-center gap-2 mb-3">
                <div className="w-2 h-2 bg-purple-500 rounded-full animate-pulse"></div>
                <span className="text-white text-xs font-bold uppercase tracking-wide">Upcoming Sermon</span>
              </div>

              {loading ? (
                <p className="text-white text-sm">Loading sermon...</p>
              ) : (
                <>
                  <img
                    src={isPastDate(latestSermon?.date) ? slide1 : latestSermon?.image}
                    alt="Sunday Message"
                    className="w-full h-32 object-cover rounded-xl mb-3"
                  />

                  <h3 className="font-heading text-white font-semibold text-lg mb-2 text-shadow-soft">
                    {latestSermon?.title}
                  </h3>

                  <p className="font-body text-gray-200 text-sm mb-3 opacity-90">
                    Join  {isPastDate(latestSermon?.date) ? 'Pastor Roshan' : latestSermon?.speaker || 'Pastor Roshan'} for an inspiring message |
                    प्रेरणादायी सन्देशका लागि पास्टर रोशनसँग सहभागी हुनुहोस्।
                  </p>

                  <div className="space-y-2 text-xs text-gray-300">
                    <div className="flex items-center gap-2">
                      <span>This Sunday | आइतबार</span>
                    </div>

                    <div className="flex items-center gap-2">
                      <span className="text-purple-300 font-semibold">
                        {getNextSunday()} | {getNextSundayNepali()}
                      </span>
                    </div>

                    <div className="flex items-center gap-2">
                      <span>{latestSermon?.time}</span>
                    </div>
                  </div>

                  {!isPastDate(latestSermon?.date) && (
                    <button
                      onClick={() => openModal('sermon')}
                      className="font-heading w-full mt-3 bg-gradient-to-r from-red-500 to-purple-600 text-white font-semibold py-2 px-4 rounded-lg text-sm"
                    >
                      View Details
                    </button>
                  )}
                </>
              )}
            </div>
          )}


          {/* Event Card */}
          {hasUpcomingEvent && activeCard === 'event' && (
            <div className="bg-gradient-to-br from-red-500/20 to-orange-500/20 backdrop-blur-lg border border-white/20 rounded-2xl p-4 shadow-2xl overflow-hidden">
              <div className="flex items-center gap-2 mb-3">
                <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></div>
                <span className="text-white text-xs font-bold uppercase tracking-wide">Upcoming Event</span>
              </div>
              {(eventOne && eventOne.videoUrl !== undefined) || (eventOne && eventOne.videoUrl) ? (
                <video
                  ref={videoRef}
                  controls
                  autoPlay
                  playsInline
                  preload="metadata"
                  poster={eventOne.image}
                  className="w-full h-full object-cover rounded-lg bg-black"
                >
                  <source src={eventOne.videoUrl} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              ) : (
                <img src={eventOne?.image ? eventOne.image : slide3} alt="New Year 2025" className="w-full h-32 object-cover rounded-xl mb-3" />
              )}
              <h3 className="font-heading text-white font-semibold text-sm mb-2 text-shadow-soft">{eventOne?.title}</h3>
              <p className="line-clamp-2 font-body text-gray-200 text-sm mb-3 opacity-90">{eventOne?.description}</p>
              <div className="space-y-2 text-xs text-gray-300">
                <div className="flex items-center gap-2">
                  <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                  <span>{eventOne?.date}</span>
                </div>
                <div className="flex items-center gap-2">
                  <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <span>{eventOne?.time}</span>
                </div>
              </div>
              <button onClick={() => openModal('event')} className="font-heading w-full mt-3 bg-gradient-to-r from-red-500 to-orange-600 hover:from-red-600 hover:to-orange-700 text-white font-semibold py-2 px-4 rounded-lg text-sm transition-all duration-300 transform hover:scale-105 tracking-wide">
                View Details
              </button>
            </div>
          )}

          {/* News Card */}
          {activeCard === 'news' && (
            <div className="bg-gradient-to-br from-purple-500/20 to-pink-500/20 backdrop-blur-lg border border-white/20 rounded-2xl p-4 shadow-2xl">
              <div className="flex items-center gap-2 mb-3">
                <div className="w-2 h-2 bg-purple-500 rounded-full animate-pulse"></div>
                <span className="text-white text-xs font-bold uppercase tracking-wide">Latest News</span>
              </div>
              {latestNews ? (
                <>
                  {latestNews.image && (
                    <img src={latestNews.image} alt={latestNews.title} className="w-full h-32 object-cover rounded-xl mb-3" />
                  )}
                  <h3 className="font-heading text-white font-semibold text-lg mb-2 text-shadow-soft line-clamp-2">{latestNews.title}</h3>
                  <p className="font-body text-gray-200 text-sm mb-3 opacity-90 line-clamp-2">{latestNews.excerpt}</p>
                  <div className="space-y-2 text-xs text-gray-300">
                    {latestNews.date && (
                      <div className="flex items-center gap-2">
                        <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                        <span>{new Date(latestNews.date).toLocaleDateString()}</span>
                      </div>
                    )}
                    {latestNews.author && (
                      <div className="flex items-center gap-2">
                        <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                        </svg>
                        <span>{latestNews.author}</span>
                      </div>
                    )}
                  </div>
                  <button onClick={() => navigate('/news-updates')} className="font-heading w-full mt-3 bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 text-white font-semibold py-2 px-4 rounded-lg text-sm transition-all duration-300 transform hover:scale-105">
                    View More
                  </button>
                </>
              ) : (
                <p className="text-white text-sm">Loading news...</p>
              )}
            </div>
          )}
        </div>

        {/* Slides Container */}
        <div
          className="flex transition-transform duration-500 ease-in-out h-full"
          style={{ transform: `translateX(-${currentSlide * 100}%)` }}
        >
          {slides.map((slide, index) => (
            <div
              key={slide.id}
              className="w-full h-full flex-shrink-0 relative"
            >
              {/* Background Image - Fixed for mobile */}
              <img
                src={slide.image}
                alt={`Slide ${slide.id}`}
                className="absolute inset-0 w-full h-full object-cover sm:object-cover object-center md:object-cover"
                style={{ objectPosition: 'center center' }}
              />

              {/* Overlay for better text readability */}
              <div className="absolute inset-0 bg-black bg-opacity-40"></div>

              {/* Slide Content - Responsive */}
              <div
                className="relative z-10 flex items-center justify-center h-full px-4 sm:px-6 lg:px-8"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              >
                <div className="text-white text-center lg:text-left max-w-4xl w-full">
                  <h1
                    className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold leading-tight mb-4 sm:mb-6 text-shadow-glow"
                    dangerouslySetInnerHTML={renderHighlightedText(slide.title, slide.highlight)}
                  >
                  </h1>
                  <p className="font-body text-base sm:text-lg md:text-xl lg:text-2xl text-gray-200 mb-24 sm:mb-32 md:mb-40 lg:mb-8 opacity-95">
                    Transforming lives through faith, hope, and love
                  </p>
                  <div className="hidden lg:flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center lg:justify-start">
                    <button onClick={() => navigate('/contactus')} className="font-heading bg-gradient-to-r from-red-500 to-purple-600 hover:from-red-600 hover:to-purple-700 text-white font-semibold py-3 px-6 sm:px-8 rounded-lg transition-all duration-300 transform hover:scale-105 text-sm sm:text-base tracking-wide">
                      Join Us Today
                    </button>
                    <button onClick={() => navigate('/aboutus')} className="font-heading border-2 border-white hover:bg-white hover:text-gray-900 text-white font-semibold py-3 px-6 sm:px-8 rounded-lg transition duration-300 transform hover:scale-105 text-sm sm:text-base tracking-wide">
                      Learn More
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Verse of the Day - Above Dots */}
        {verseOfDay && (
          <div className="absolute bottom-12 sm:bottom-14 left-1/2 transform -translate-x-1/2 w-11/12 sm:w-4/5 md:w-3/4 lg:w-3/5 z-30">
            <div className="bg-gradient-to-br from-purple-500/20 to-pink-500/20 backdrop-blur-lg border border-white/20 rounded-xl sm:rounded-2xl p-3 sm:p-5 md:p-6 shadow-2xl">
              <div className="flex items-center justify-center gap-2 mb-2 sm:mb-3">
                <svg className="w-4 h-4 sm:w-5 sm:h-5 text-purple-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                </svg>
                <h3 className="text-xs sm:text-base md:text-lg font-bold text-purple-200">Verse of the Day | आजको पद</h3>
              </div>
              <div className="text-center space-y-1 sm:space-y-2">
                <p className="text-xs sm:text-base md:text-lg text-white font-serif italic leading-relaxed">
                  "{verseOfDay.english}"
                </p>
                <p className="text-xs sm:text-sm md:text-base text-purple-100 font-serif italic leading-relaxed">
                  "{verseOfDay.nepali}"
                </p>
                <p className="text-purple-300 font-semibold text-xs sm:text-sm md:text-base">
                  {verseOfDay.reference} | {verseOfDay.referenceNepali}
                </p>
              </div>
            </div>
          </div>
        )}

        {/* Navigation Dots */}
        <div className="absolute bottom-4 sm:bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-2 sm:space-x-3 z-40">
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`w-2 h-2 sm:w-3 sm:h-3 rounded-full transition duration-300 ${index === currentSlide
                ? 'bg-white scale-125'
                : 'bg-white bg-opacity-50 hover:bg-opacity-75'
                }`}
            />
          ))}
        </div>

        {/* Navigation Arrows */}
        <button
          onClick={() => setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length)}
          className="hidden sm:block absolute left-4 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 hover:bg-opacity-75 text-white p-2 sm:p-3 rounded-full transition duration-300"
        >
          <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>

        <button
          onClick={() => setCurrentSlide((prev) => (prev + 1) % slides.length)}
          className="hidden sm:block absolute right-4 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 hover:bg-opacity-75 text-white p-2 sm:p-3 rounded-full transition duration-300"
        >
          <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>

      {/* Sermons Section */}
      <section id="sermons">
        <SermonsSection />
      </section>

      {/* Ministries Section */}
      <section id="ministries">
        <Ministries />
      </section>

      {/* Services Section */}
      <section id="services">
        <Services />
      </section>
    </div>
  );
};

export default Home;
